import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const IconProviderIconic21 = ({ className }) => (
  <svg className={classNames('producers-svg-icon', className)} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36.55 33.157L39.3034 55L28.2027 37.8167L19.404 43.7723L22.1495 34.64L4 32.4894L23.4401 25.5215L20.9698 5L31.9557 20.9721L40.8553 14.8137L37.993 24.202L56 26.3172L36.552 33.155L36.55 33.157Z" fill="#E91339" />
  </svg>
);

IconProviderIconic21.propTypes = {
  className: PropTypes.string,
};

IconProviderIconic21.defaultProps = {
  className: '',
};
